/**
 * ApiError — the single error type this package throws.
 *
 * Every non-2xx response is normalized into an `ApiError` with:
 *   - `status`: the HTTP status (number)
 *   - `body`:   the parsed body (JSON if the response advertised JSON,
 *               otherwise the raw text)
 *   - `url`:    the fully-resolved request URL
 *
 * Message selection, in priority order:
 *   1. `body.message`
 *   2. `body.error`
 *   3. `HTTP <status>`
 *
 * Consumers should branch on `err.status` (not the message) for
 * programmatic handling. For display, `err.message` is safe.
 */
export class ApiError extends Error {
  /**
   * @param {number}          status
   * @param {unknown}         body    Parsed body (object/array/string).
   * @param {string}          url
   */
  constructor(status, body, url) {
    const message =
      (body && typeof body === "object" && (body.message || body.error)) ||
      `HTTP ${status}`;
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
    this.url = url;
  }
}
